import React from 'react';
import Container from '../../../components/UI/Container';
import { enFr } from '../../../utils';
import WhyUsSectionWrapper from './whyUs.style';

const CheckIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f16600" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const WhyUsSection = () => {
  const credentials = [
    enFr('Master\u2019s degree in Engineering', 'Maîtrise en génie'),
    enFr('20+ years of technical leadership', '20+ années de leadership technique'),
    enFr('Founded and scaled a software company', 'Fondation et croissance d\u2019une entreprise logicielle'),
    enFr('Architect of production systems used by millions', 'Architecte de systèmes de production utilisés par des millions'),
    enFr('Organized, stakeholder-aligned approach', 'Approche organisée et alignée avec les parties prenantes'),
    enFr('Remote-first delivery worldwide', 'Livraison à distance à l\u2019échelle mondiale'),
  ];

  return (
    <WhyUsSectionWrapper id="about">
      <Container>
        <div className="why-us-content">
          <div className="left-col">
            <h2>
              {enFr('Why Awaken Solutions', 'Pourquoi Awaken Solutions')}
            </h2>
            <p className="lead">
              {enFr(
                'Not a generic agency. Not a team of subcontractors. Awaken Solutions is a hands-on technical firm that designs, builds, and integrates, grounded in two decades of shipping production software.',
                'Pas une agence générique. Pas une équipe de sous-traitants. Awaken Solutions est une firme technique qui conçoit, construit et intègre, ancrée dans deux décennies de livraison de logiciels en production.'
              )}
            </p>
            <p className="secondary">
              {enFr(
                'When you work with Awaken Solutions, you get direct access to senior engineering leadership, not a project manager relaying messages. Whether it\u2019s a custom web application, an AI integration, or a full systems overhaul, every engagement is grounded in real-world technical execution.',
                'Lorsque vous travaillez avec Awaken Solutions, vous bénéficiez d\u2019un accès direct à la direction technique senior, pas un gestionnaire de projet qui relaie des messages. Qu\u2019il s\u2019agisse d\u2019une application web sur mesure, d\u2019une intégration IA ou d\u2019une refonte complète de systèmes, chaque engagement est ancré dans l\u2019exécution technique concrète.'
              )}
            </p>
          </div>
          <div className="right-col">
            <div className="credentials-card">
              <h3>{enFr('The Foundation', 'Les fondations')}</h3>
              <ul>
                {credentials.map((item, index) => (
                  <li key={index}>
                    <CheckIcon />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="emphasis-card">
              <p>
                {enFr(
                  'You\u2019re not getting theory or templated solutions. You\u2019re getting deep technical expertise applied to your specific business challenges.',
                  'Vous n\u2019obtenez pas de la théorie ou des solutions toutes faites. Vous obtenez une expertise technique approfondie appliquée à vos défis commerciaux spécifiques.'
                )}
              </p>
            </div>
          </div>
        </div>
      </Container>
    </WhyUsSectionWrapper>
  );
};

export default WhyUsSection;
